import React, {useState} from 'react'
import { Layout , Affix} from 'antd';

import styled from 'styled-components'
import {  Route, Switch, useRouteMatch } from 'react-router-dom';
import SideMenu from './sidebar'
// import Products from './pages/products'
import Header from './header'

import Blog from './pages/blog'
import CreateBlog from './pages/blog/createblog'
import EditBlog from './pages/blog/editblog'



import News from './pages/news'
import CreateNews from './pages/news/createnews'
import EditNews from './pages/news/editnews'



import Events from './pages/events/index'
import CreateEvents from './pages/events/createevents'
import EditEvents from './pages/events/edit2'


import Jobs from './pages/jobs/index'
import CreateJobs from './pages/jobs/createjobs'
import EditJob from './pages/jobs/editjob'

import Subscriber from './pages/subscribers/index'
import Resumes from './pages/resume/index'
import Enquiry from './pages/contact/index'



const {  Content } = Layout;

export default function Dashboard() {

const [collapsed, setCollapsed] = useState(false)
const [theme, setTheme] = useState(true)



let { path } = useRouteMatch();


const toggle = () =>{
setCollapsed(!collapsed)
}


const changeTheme = () =>{
setTheme(!theme)
}

return (
  <DashboardWrap color={theme}>

<Layout >
  <Affix  offsetTop={0}>
 <SideMenu collapsed={collapsed} color={theme} click={changeTheme}/>
 </Affix>
  <Layout className="site-layout">

    <Header click={toggle} collapsed={collapsed}/>

    <Content
      className="site-layout-background"
      style={{
        margin: '24px 16px',
        padding: 24,
        minHeight: 280,
      }}
    >

<Switch>


<Route exact path = {`${path}/blog`} component={Blog}/> 
<Route  exact path={`${path}/create-blog`}  component={CreateBlog} /> 
<Route  exact path={`${path}/edit-blog/:id`}  component={EditBlog} />


<Route exact path = {`${path}/news`} component={News}/> 
<Route  exact path={`${path}/create-news`}  component={CreateNews} /> 
<Route  exact path={`${path}/edit-news/:id`}  component={EditNews} />


<Route exact path = {`${path}/events`} component = {Events}/>
<Route  exact path={`${path}/create-events`}  component={CreateEvents} /> 
<Route exact path = {`${path}/edit-events/:id`} component={EditEvents} />



<Route exact path = {`${path}/jobs`} component={Jobs}/> 
<Route  exact path={`${path}/create-job`}  component={CreateJobs} /> 
<Route  exact path={`${path}/edit-job/:id`}  component={EditJob} />

<Route exact path ={`${path}/subscribers`} component={Subscriber}/>
<Route exact path ={`${path}/resume`} component={Resumes}/>
<Route exact path = {`${path}/enquiry`} component={Enquiry}/>





 





</Switch>

      </Content>
      </Layout>
      </Layout>
            
        </DashboardWrap>
    )
}


const DashboardWrap = styled.div`



.ant-layout {

    .ant-layout-sider{
        height: 100vh;
        /* height: 100vh; */

        background:${props => props.color ? "#001529" : "#ffffff"};
    }
}



.logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}



#components-layout-demo-custom-trigger .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}

.site-layout .site-layout-background {
  background: #fff;
}
`